import { canManagePost, canUpdatePost } from "@/react/helpers/postHelpers";
import { SECTIONS } from "@circle-react/components/EventsV3/Modal/utils/constants";
import { useEditEventModal } from "@circle-react/components/Modals/EditEventModal";
import type { Event } from "@circle-react/types/Event";
import { useAttendeesModal } from "../AttendeesModal";

export const useAttendeesPreview = (event: Event) => {
  const {
    event_setting_attributes: eventSettingAttributes,
    event_attendees: eventAttendees,
    slug,
    space_slug: spaceSlug,
  } = event || {};
  const canManageEvent = canManagePost(event);
  const canUpdateEvent = canUpdatePost(event);
  const editEventModal = useEditEventModal();
  const attendeesModal = useAttendeesModal();
  const { records: attendees, count: totalCount } = eventAttendees || {};
  const { hide_attendees: shouldHideAttendees, rsvp_disabled: isRsvpDisabled } =
    eventSettingAttributes || {};

  if (isRsvpDisabled || shouldHideAttendees) {
    return null;
  }

  const handleAttendeesClick = () => {
    if (!spaceSlug || !slug) {
      return;
    }

    if (canUpdateEvent) {
      void editEventModal.show({
        event: event,
        defaultSection: SECTIONS.people,
        locationType: event.event_setting_attributes?.location_type,
      });
    } else {
      void attendeesModal.show({ event });
    }
  };

  return {
    attendees,
    totalCount,
    canManageEvent,
    handleAttendeesClick,
    canUpdateEvent,
  };
};
